/**
 * @file environment.production.ts
 * @description Production environment configuration — applied at runtime
 * by `environment.ts` when the browser hostname doesn't match any of the
 * localhost / staging patterns (i.e. the app is deployed to
 * `www.kirigami.ai` or a similar production host).
 *
 * Cognito pool IDs, auth domain, and the Paddle client-side token are
 * public identifiers (safe to commit).
 */
import type { Environment } from './environment.model';

export const environment: Environment = {
  stage: 'prod',
  production: true,
  apiBaseUrl: 'https://api-prod.kirigami.ai/v1',
  kbapiBaseUrl: 'https://kbapi.kirigami.ai/v1',
  gtm_id: 'GTM-KGZTTFW3',
  cognito: {
    userPoolId: 'eu-west-1_58h8n5oqS',
    pubClientId: '5b2v0jillq57nme2uib8j3lpjm',
    priClientId: '78imrt1mqsk7jh8lf39c0d3tc9',
    region: 'eu-west-1',
    domain: 'auth-prod.kirigami.ai',
    responseType: 'code',
    scope: 'email openid profile phone aws.cognito.signin.user.admin',
  },
  paddle: {
    token: 'live_de92bfdfc581504e2a56d1d4e1f',
    priceId_1: 'pri_01kpv071sdwgksfgxzr44e4yry',
    priceId_2: 'pri_01k82xw4njskpe54gzsv96srtd',
    priceId_3: 'pri_01k82xxmwzrebqsb40g6qpa0kj',
    // Live prices under product "Kirigami Subscription" (pro_01ky01gb4pyfeny7w6k4hq87w8).
    // Mini-Lab and the PAYG top-up have no live price yet — those tiers fall
    // back to Contact Sales until their ids are added here.
    priceId_researcher_monthly: 'pri_01ky01kkwz9h99a289jkvg45vk',
    priceId_researcher_annual: 'pri_01ky01qq6gyegk1nbfkad45fk3',
    priceId_researcher_pro_monthly: 'pri_01ky01stka7ewf6cv0yse7dkma',
    priceId_researcher_pro_annual: 'pri_01ky01y8naedfxkrvr5hdav46f',
  },
};
